import type { BadgeProps } from "@/components/ui/primitives"

export type ProjectShareAccessKind = "view" | "settings" | "content"

/** Нормализует access_level шары: неизвестное значение считаем content. */
export function projectShareAccessKind(level: string | null | undefined): ProjectShareAccessKind {
  if (level === "view") return "view"
  if (level === "settings") return "settings"
  return "content"
}

export const PROJECT_SHARE_ACCESS_TONE: Record<ProjectShareAccessKind, BadgeProps["tone"]> = {
  settings: "amber",
  content: "sky",
  view: "neutral",
}

export function projectShareAccessLabel(
  level: string | null | undefined,
  labels: Record<ProjectShareAccessKind, string>,
): string {
  return labels[projectShareAccessKind(level)]
}

/** Архив / дубль / экспорт / restore остаются у компании-владельца (или super-admin). */
export function canUseOwnerProjectActions(shared: boolean | undefined, isSuperAdmin: boolean): boolean {
  return !shared || isSuperAdmin
}
